import { ModalHistoricoUploadsController } from './modal-historico-uploads.controller'

(function() {

  'use strict';

  function UploadImportPlaniCtrl($scope, $rootScope, $state, $uibModal, $mdToast, $timeout, localStorageService, Upload, UploadResource, UploadService, Pedido, PUBLIC_API, URL, URLADMINV3) {
    var vm = this;

    // Remove sessionStorage Itens
    vm.sessionStorageItens = ['uploadFileError', 'startUploadTime', 'endUploadTime', 'startProccessTime', 'endProccessTime'];
    vm.i = vm.sessionStorageItens.length;
    while (vm.i--) {
      sessionStorage.removeItem(vm.sessionStorageItens[vm.i]);
    }

    // Calcula o tempo gasto para cada etapa
    vm.calculateTimeSpent = function(timeInit, timeFinish) {
      var timeDiff = sessionStorage.getItem(timeFinish) - sessionStorage.getItem(timeInit);
      var timeSpent = timeDiff / 1000;
      return timeSpent;
    };

    vm.errorMessage = '';
    vm.uploadInitiated = '';
    vm.proccessInitiated = '';
    vm.showButton = true;

    var mandaePedidoId = Pedido.getPedidoId();

    $scope.uploadFiles = function(file, errFiles) {
      $scope.f = file;
      $scope.errFile = errFiles && errFiles[0];
      if (file) {
        vm.uploadInitiated = true;
        vm.showButton = false;
        vm.errorMessage = '';
        sessionStorage.setItem('startUploadTime', Date.now());
        file.upload = Upload.upload({
          url: URLADMINV3 + '/planilha/upload?clienteId=' + localStorageService.get('user').id,
          method: 'POST',
          data: { file: file }
        });

        file.upload.then(function(response) {

          if (response.status === 200) {
            vm.uploadInitiated = false;
            vm.proccessInitiated = true;
            vm.timeelapsed = vm.calculateTimeSpent('startUploadTime', 'endUploadTime');
            var s3FileNameId = response.data.s3FileNameId;

            sessionStorage.setItem('endUploadTime', Date.now());
            sessionStorage.setItem('startProccessTime', Date.now());

            UploadService.proccessFileAsync({s3FileNameId:s3FileNameId, mandaePedidoId:mandaePedidoId})
              .then(function(data) {
                vm.proccessInitiated = false;
                vm.uploadInitiated = false;
                vm.showButton = true;
                showAlert('O arquivo está sendo processado, você pode ver o progresso clicando no botão "UPLOADS RECENTES"');
              })
              .catch(function(err) {
                vm.proccessInitiated = false;
                vm.uploadInitiated = false;
                vm.showButton = true;
              });
          } // 200
          else {
            vm.errorMessage = 'Ocorreu o erro, tente novamente.';
          }
          $timeout(function() {
            file.result = response.data;
          });
        }, function(response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function(evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      } else {
        vm.errorMessage = 'Aceitamos apenas arquivos CSV, XLS e XLSX.';
      }
    }

    vm.abrirModalHistoricoUploads = function() {
      $uibModal.open({
        animation: false,
        template: require('./modal-historico-uploads.html'),
        controller: ModalHistoricoUploadsController,
        controllerAs: 'vm',
        windowClass: 'modal-historico-uploads',
        resolve: { valor: () => null }
      });
    }

    function showAlert(content) {
      var toast = $mdToast.simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position('top right')
        .hideDelay(5000);

      return $mdToast.show(toast);
    }

  };

  angular
    .module('mandaeApp')
    .controller('UploadImportPlaniCtrl', UploadImportPlaniCtrl);

})();
